import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AboutBannerImg1 from '../assets/images/about-banner-2.png';
import AboutBannerImg2 from '../assets/images/about-banner-3.png';
import { ASSETS_URL } from '../api/constants';

const AboutBox = ({ section3, section4 }) => {
  const section3Image = section3?.image ? `${ASSETS_URL}/${section3.image}` : AboutBannerImg1;
  const section4Image = section4?.image ? `${ASSETS_URL}/${section4.image}` : AboutBannerImg2;

  const section3Title = section3?.title || '<span>Jambobay</span> is here for you,';
  const section3SubDesc = section3?.sub_description || 'Every step of the way';
  const section3Description = section3?.description || `
    <p>Jambobay is incredibly personal — and for most people, it's the biggest transaction they'll ever make.</p>
    <p>Jambobay is built on a deep understanding of movers' needs...</p>
    <p>That's also why Jambobay provides a suite of products and services...</p>
  `;

  const section4Title = section4?.title || 'Modernizing the real estate <span class="text-black">experience</span>';
  const section4Description = section4?.description || `
    <p>Buying and selling real estate is a difficult process to navigate...</p>
    <p>Jambobay, the housing super app, solves these real pain points...</p>
  `;

  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img src={section3Image} alt={section3?.title || 'Modern House'} className="house-img" />
          </div>
        </Col>
        <Col lg={6} md={12} className='about-content-box align-self-center'>
          <div className="about-content">
            <h1 className="about-title" dangerouslySetInnerHTML={{ __html: section3Title }} />
            <p className="about-subtitle pb-40">{section3SubDesc}</p>
            <div className="about-description" dangerouslySetInnerHTML={{ __html: section3Description }} />
          </div>
        </Col>

        <Col lg={6} md={12} className='about-content-box align-self-center order-2 order-lg-0'>
          <div className="about-content">
            <h1 className="about-title" dangerouslySetInnerHTML={{ __html: section4Title }} />
            <div className="about-description" dangerouslySetInnerHTML={{ __html: section4Description }} />
          </div>
        </Col>
        <Col lg={6} md={12} className="order-1 order-lg-0">
          <div className="about-image">
            <img src={section4Image} alt={section4?.title || 'Modern House'} className="house-img" />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default AboutBox;